import 'react-toastify/dist/ReactToastify.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import './layout.css';
import './prototypes.js';
import './overrides.js';
import './src/locales/config';

import SnackMessageProvider from 'components/base/context/snack/SnackMessageProvider';
import ServiceWorkerUpdatePopup from 'components/base/ServiceWorkerUpdatePopup';
import { routes } from 'constants/routes';
import { navigate } from 'gatsby';
import i18n from 'locales/config';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import api from 'utils/api';
import { setAppBootstrapPromise } from 'utils/appBootstrap';
import { getRefreshToken } from 'utils/hooks/storage/storageGets';
import { setStoragePath } from 'utils/hooks/storage/storageSets';
import { checkServiceWorkerUpdate, initializeServiceWorkerUpdates, serviceWorkerUpdateReady } from 'utils/serviceWorkerUpdates';

import PermissionProvider from './PermissionProvider';
import ProvidersWrapper from './ProvidersWrapper';

export const wrapRootElement = ({ element }) => (
	<I18nextProvider i18n={i18n}>
		<ProvidersWrapper>
			<PermissionProvider>
				<SnackMessageProvider>
					{element}
					<ServiceWorkerUpdatePopup />
				</SnackMessageProvider>
			</PermissionProvider>
		</ProvidersWrapper>
	</I18nextProvider>
);

export const onClientEntry = () => {
	initializeServiceWorkerUpdates();
	const refreshToken = getRefreshToken();
	if(!refreshToken) {
		const shouldSavePath =
			window.location.pathname !== routes.PL.COMPLIANCE &&
			window.location.pathname !== routes.PAGE_NOT_FOUND &&
			window.location.pathname !== routes.DASHBOARD &&
			window.location.pathname !== routes.SIGN_IN &&
			window.location.pathname !== '/';
		if(shouldSavePath) {
			setStoragePath(`${window.location.pathname.replace(/\/+$/, '')}${window.location.search}`);
		}
		setAppBootstrapPromise(Promise.resolve());
	} else {
		setAppBootstrapPromise(Promise.allSettled([
			api.user.initUserData(),
			api.commons.getStaticData(),
		]));
	}
};

export const onRouteUpdate = ({ location }) => {
	checkServiceWorkerUpdate();

	const refreshToken = getRefreshToken();
	if (!refreshToken) {
		if(location.pathname !== routes.SIGN_IN && location.pathname !== routes.PL.COMPLIANCE) {
			navigate(routes.SIGN_IN);
		}
	} else {
		if(location.pathname === '/' || location.pathname === routes.SIGN_IN) {
			navigate(routes.DASHBOARD, { replace: true });
		} else {
			savePreviousPath();
		}
	}
};

const savePreviousPath = () => {
	window.locations = window.locations || [document.referrer];
	window.locations.push(window.location.href);
};

export const shouldUpdateScroll = ({
	routerProps,
	prevRouterProps,
	getSavedScrollPosition,
}) => {
	const prev = prevRouterProps?.location;
	const next = routerProps.location;

	if (!prev) return true;

	const onlyQueryChanged =
    prev.pathname === next.pathname && prev.search !== next.search;

	if (onlyQueryChanged) {
		return false;
	}

	if (next.state?.noScroll) {
		return false;
	}

	const position = getSavedScrollPosition(next) || getSavedScrollPosition(prev);

	if (position) {
		setTimeout(() => {
			window.scrollTo(...position);
		}, 10);
		return false;
	}

	return true;
};

export const onServiceWorkerUpdateReady = ({ serviceWorker }) => {
	window.___swUpdated = false;
	serviceWorkerUpdateReady(serviceWorker);
};
